const hasCssGridSupport = () =>
  typeof document.createElement('div').style.grid === 'string';

export default hasCssGridSupport;
